<template>
  <div class="modal animated fadeIn" id="modal-notifications" tabindex="-1" role="dialog">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('notifications_modal.notifications') }}</p>
      </header>

      <section class="modal-card-body">

        <!-- Button Toggle Group -->
        <div class="button-group">
          <button class="left btn btn-default" :class="{'active': showingNotifications}" @click="showNotifications" style="width: 50%;">
            {{ $t('notifications_modal.notifications') }}
          </button>
          <button class="right btn btn-default" :class="{'active': showingAnnouncements}" @click="showAnnouncements" style="width: 50%;">
            {{ $t('notifications_modal.announcements') }}
            <i class="fa fa-circle text-danger p-l-xs" v-if="options.hasUnreadAnnouncements"></i>
          </button>
        </div>

        <!-- Informational Messages -->
        <div class="notification-container" v-if="options.loadingNotifications">
          <i class="fa fa-btn fa-spinner fa-spin"></i>Loading Notifications
        </div>

        <div class="notification-container" v-if=" ! options.loadingNotifications && activeNotifications.length == 0">
          <div class="alert alert-warning m-b-none">
            We don't have anything to show you right now! But when we do, we'll be sure to let you know. Talk to you soon!
          </div>
        </div>

        <!-- List Of Notifications -->
        <div class="notification-container" v-if="showingNotifications && hasNotifications">
          <div class="notification" v-for="notification in options.notifications" :key="notification.id">

            <!-- Notification Icon -->
            <figure>
              <img v-if="notification.creator" :src="notification.creator.photo_url" class="spark-profile-photo">

              <span v-else class="fa-stack fa-2x">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i :class="['fa', 'fa-stack-1x', 'fa-inverse', notification.icon]"></i>
              </span>
            </figure>

            <!-- Notification -->
            <div class="notification-content">
              <div class="meta">
                <p class="title">
                  <span v-if="notification.creator">
                    {{ notification.creator.name }}
                  </span>

                  <span v-else>
                  </span>
                </p>

                <div class="date">
                  {{ notification.created_at | relative }}
                </div>
              </div>

              <div class="notification-body" v-html="notification.parsed_body"></div>

              <!-- Notification Action -->
              <a :href="notification.action_url" class="button is-primary is-medium" v-if="notification.action_text">
                {{ notification.action_text }}
              </a>

            </div>
          </div>
        </div>

        <!-- List Of Announcements -->
        <div class="notification-container" v-if="showingAnnouncements && hasAnnouncements">
          <div class="notification" v-for="announcement in options.announcements" :key="announcement.id">

            <!-- Notification Icon -->
            <figure>
              <img :src="announcement.creator.photo_url" class="spark-profile-photo">
            </figure>

            <!-- Announcement -->
            <div class="notification-content">
              <div class="meta">
                <p class="title">@{{ announcement.creator.name }}</p>

                <div class="date">
                  {{ announcement.created_at | relative }}
                </div>
              </div>

              <div class="notification-body" v-html="announcement.parsed_body"></div>

              <!-- Announcement Action -->
              <a :href="announcement.action_url" class="button is-primary is-medium" v-if="announcement.action_text">
                {{ announcement.action_text }}
              </a>

            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options"],

  /**
     * The component's data.
     */
  data() {
    return {
      Events: window.Events,
      showingNotifications: true,
      showingAnnouncements: false
    };
  },

  methods: {
    closeModal() {
      this.Events.$emit("modalClose", "notificationsModal");
    },

    /**
       * Show the user notifications.
       */
    showNotifications() {
      this.showingNotifications = true;
      this.showingAnnouncements = false;
    },

    /**
       * Show the product announcements.
       */
    showAnnouncements() {
      this.showingNotifications = false;
      this.showingAnnouncements = true;

      this.updateLastReadAnnouncementsTimestamp();
    },

    /**
       * Update the last read announcements timestamp.
       */
    updateLastReadAnnouncementsTimestamp() {
      axios.put("/user/last-read-announcements-at").then(() => {
        Bus.$emit("updateUser");
      });
    }
  },

  computed: {
    /**
       * Get the active notifications or announcements.
       */
    activeNotifications() {
      if (!this.options.notifications) {
        return [];
      }

      if (this.showingNotifications) {
        return this.options.notifications;
      } else {
        return this.options.announcements;
      }
    },

    /**
       * Determine if the user has any notifications.
       */
    hasNotifications() {
      return (
        this.options.notifications && this.options.notifications.length > 0
      );
    },

    /**
       * Determine if the user has any announcements.
       */
    hasAnnouncements() {
      return (
        this.options.announcements && this.options.announcements.length > 0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
.modal-background {
  background: hsla(0, 0%, 100%, 0.3);
}

#modal-notifications {
  .modal-card {
    .modal-card-head {
      padding-bottom: 30px;
    }
    .modal-card-body {
      padding-bottom: 40px;
    }
  }
}

.button-group {
  display: flex;
  max-width: 366px;
  text-align: center;
  margin: 0 auto 30px;
  button {
    border: 1px solid $green;
    background: $white;
    margin: 0;
    text-transform: uppercase;
    padding: 12px 15px;
    letter-spacing: 1px;
    font-size: 10px;
    outline: none;
    &:hover {
      cursor: pointer;
    }
    &.left {
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    }
    &.right {
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    &.active {
      background: $green;
      color: $white;
    }
  }
}

.notification-container {
  .notification {
    border: 1px solid lighten($mutedblue, 12%);
    border-radius: 5px;
    margin-bottom: 10px;
    background: $white;
    display: flex;
    padding: 2.5rem 2.5rem 1.5rem;
    figure {
      line-height: 0;
      img {
        width: 56px;
        border-radius: 100px;
        border: 1px solid lighten($mutedblue, 12%);
      }
      span {
        color: $purple;
      }
    }
    .notification-content {
      padding: 0 0 0 20px;
      .title,
      .subtitle {
        margin-bottom: 0;
      }
      .title {
        font-size: 20px;
      }
      .date {
        font-style: italic;
      }
      .notification-body {
        margin-top: 0;
      }
      a {
        margin-top: 20px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// notifications-modal.vue?a2f16d66